module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/economics-disabled-hover-50.3931c8ed.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/economics-disabled-hover-50.png
// module id = 3432
// module chunks = 11